import DefaultSpinLoading from 'shared/ui/DefaultspinLoading'
import Style from './style'

const RankingInfoLoading = () => {
	return (
		<div style={{display: 'flex', flexDirection: 'column', gap: '24px'}}>
			<Style.WeightTable
				style={{
					flex: 1,
					display: 'flex',
					width: '100%',
					minHeight: '100dvh',
					justifyContent: 'center',
				}}
			>
				<DefaultSpinLoading />
			</Style.WeightTable>
		</div>
	)
}

export default RankingInfoLoading
